import React from 'react';

export const getErrorDisplay = (errors, invalid = true) =>
  errors ? <div>{invalid && <small className="text-danger">{errors}</small>}</div> : null;
